import {Component, Input} from '@angular/core';
import {EventsService} from '../../../../../../../../@shared/services/events-service';
import {EventClassResponse, EventResponse} from '../../../../../../../../@shared/models/response.module';
import {_AQH_EVE_10, _AQH_EVE_9, AQH_EVE_6} from '../../../../../../../../@shared/models/input.module';
import {EVENT_CLASS_STATUSES, formatTimeDMYHHMM} from '../../../../../../../../@core/utils/utils.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AddClass} from './components/add-class/add-class';
import {EditClass} from './components/edit-class/edit-class';
import {DeleteModal} from '../../../../../../../../@shared/components/delete-modal/delete-modal';
import {ViewClassRegistrations} from './components/view-class-registrations/view-class-registrations';

@Component({
  selector: 'app-manage-event-classes',
  standalone: false,
  templateUrl: './manage-event-classes.html',
  styleUrl: './manage-event-classes.css'
})
export class ManageEventClasses {
  @Input() event: EventResponse
  eventClasses: EventClassResponse[]

  constructor(private eventService: EventsService,
              private modalService: NgbModal) {
  }

  ngOnInit() {
    this.getEventClasses()
  }

  getEventClasses() {
    let params: AQH_EVE_6 = {
      event_id: this.event.event_id
    }
    this.eventService.getEventClasses(params).subscribe((data) => {
      this.eventClasses = data
      console.log("Event Classes: ", data);
    });
  }

  getTotalRegistrations() {
    let registrations = 0;

    for (let eventClass of this.eventClasses) {
      registrations += eventClass.event_class_registrations.length;
    }
    return registrations
  }

  openAddEventClassModal() {
    let modalRef = this.modalService.open(AddClass, { size: 'lg', centered: true });
    modalRef.componentInstance.event = this.event;
    modalRef.result.then((res) => {
      if (res){
        this.getEventClasses()
      }
    })
  }

  openEditEventClassModal(eventClass: EventClassResponse) {
    let modalRef = this.modalService.open(EditClass, { size: 'lg', centered: true });
    modalRef.componentInstance.eventClass = eventClass;
    modalRef.result.then((res) => {
      if (res){
        this.getEventClasses()
      }
    })
  }

  openViewRegistrationsModal(eventClass: EventClassResponse) {
    let modalRef = this.modalService.open(ViewClassRegistrations, { size: 'xl', centered: true });
    modalRef.componentInstance.eventClass = eventClass;

    modalRef.result.then((updated) => {
      if (updated) {
        // Refresh the event classes list to show updated data
        this.getEventClasses();
      }
    }, () => {
      // Modal dismissed without changes
    });
  }


  deleteEventClass(eventClass: EventClassResponse) {
    let modalRef = this.modalService.open(DeleteModal, { size: 'md', centered: true });
    modalRef.result.then((res) => {
      console.log("Delete modal result: ", res);
      if (res){
        let params: _AQH_EVE_9 = {
          event_id: this.event.event_id,
          event_class_id: eventClass.event_class_id
        }
        this.eventService.deleteEventClass(params).subscribe((res) => {
          this.getEventClasses()
        })
      }
    })
  }

  updateEventClassStatus(eventClass: EventClassResponse, newStatus: number) {
    let params: _AQH_EVE_10 = {
      event_class_id: eventClass.event_class_id,
      event_class_status_id: newStatus
    }
    this.eventService.editEventClassStatus(params).subscribe((res) => {
      this.getEventClasses()
    })
  }

  protected readonly formatTimeDMYHHMM = formatTimeDMYHHMM;
  protected readonly EVENT_CLASS_STATUSES = EVENT_CLASS_STATUSES;
}
